import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { getLinkNewAssesorForm } from './link-assessor.component.element';
import { TrainingPartnerService, ASSESSOR_STATUS } from 'projects/services/src/app/API/training-partner.service';
import { AssessmentAgencyService } from 'projects/services/src/app/API/assessment-agency.service';
import { UserService } from 'projects/services/src/app/API/user.service';
import { IDFormControl } from '../../d-form/d-form.helpers';
import { STATE } from 'projects/training-partner/src/app/training-partner/constants';
import { LoadingService } from 'projects/services/src/app/loading.service';
export const FORM_STATE = STATE;
@Component({
	selector: 'app-link-assessor',
	templateUrl: './link-assessor.component.html',
	styleUrls: ['./link-assessor.component.css']
})
export class LinkAssessorComponent implements OnInit, OnChanges {
	linkNewAssesorForm: any;
	assessor: any;
	myAssessmentAgenciesList: any = [];
	formLoaded: boolean;
	@Input() selectedSchemeId: string;
	@Output() generateOtp = new EventEmitter();
	@Output() editAssessor = new EventEmitter();
	@Output() controlChange = new EventEmitter();
	@Input() defaultDetails: any = {};
	linkAssessorFormControl: IDFormControl;
	@Input() state = STATE.FILLING;
	visible = true;
	constructor(
		private trainingPartnerService: TrainingPartnerService,
		private assessmentAgencyService: AssessmentAgencyService,
		private userService: UserService,
		private loadingService: LoadingService
	) { }

	ngOnChanges(changes) {
		if (changes && changes.state) {
			this.visible = false;
			setTimeout(() => this.ngOnInit());
		}
	}

	ngOnInit() {
		let submitText;
		const cancelText = 'Cancel';
		const hide: any = {};
		const disabled: any = {};
		switch (this.state) {
			case STATE.FILLING: {
				submitText = 'Generate OTP';
				break;
			}
			case STATE.EDITING: {
				submitText = 'Save';
				disabled.assessorId = true;
				break;
			}
			case STATE.VIEWING: {
				submitText = 'Ok';
				disabled.all = true;
				break;
			}
		}
		this.assessmentAgencyService.getAssesmentAgency({ noPagination: true }, {
			type: 'Feebased',
			schemeid: this.selectedSchemeId
		}).subscribe(({ data, pagination }) => {
			this.myAssessmentAgenciesList = data.map(ag => {
				return {
					name: `${ag.name} - (${ag.userName})`,
					value: {
						userName: ag.userName,
						name: ag.name
					}
				};
			});
			this.linkNewAssesorForm = getLinkNewAssesorForm(
				Object.assign({}, {
					assessmentAgencyOptions: this.myAssessmentAgenciesList,
					submitText,
					cancelText
				}, this.defaultDetails),
				{
					blurAssessorId: this.onAssessorId.bind(this),
					assessorIdChange: this.onAssessorIdChange.bind(this)
				}, hide, disabled
			);
			this.formLoaded = true;
			this.visible = true;
		});
	}

	resetForm() {
		this.linkAssessorFormControl.reset();
	}

	emitFormControl() {
		this.controlChange.emit(this.linkAssessorFormControl);
	}

	onSubmit(data) {
		if (this.linkAssessorFormControl.isValid()) {
			data = this.linkAssessorFormControl.value();
			switch (this.state) {
				case STATE.FILLING: {
					this.onGenerateOtp(data);
					break;
				}
				case STATE.EDITING: {
					this.editAssessor.emit(Object.assign({}, this.defaultDetails, data))
					// alert('EDITING');
					break;
				}
				case STATE.VIEWING: {
					// alert('VIEWING');
					break;
				}
			}
		}
	}

	onGenerateOtp(data) {
		this.loadingService.blockModal();
		const assessmentAgencyUserName = data.assessmentAgencyAligned;
		this.userService.generateOTP(this.assessor.userName, UserService.USER_STEP.LINK_ASSESSOR_TO_ASSESSMENT_AGENCY).subscribe(
			res => {
				this.loadingService.unblockuI();
				this.assessor.assessmentAgencyUserName = assessmentAgencyUserName;
				Object.assign(this.assessor, this.linkAssessorFormControl.value());
				this.resetForm();
				console.log('111111111111111111111111111111111111111111111', this.assessor);

				this.generateOtp.emit(this.assessor);
			},
			err => {
				this.loadingService.unblockuI();
			}
		);
	}

	onAssessorIdChange() {
		this.linkAssessorFormControl.patchValues({
			nameOfAssessor: null
		});
		// this.linkNewAssesorForm.forms[0].formRef.controls.nameOfAssessor.setValue(
		// 	null
		// );
	}
	onAssessorId(data) {
		if (!data) {
			return;
		}
		this.trainingPartnerService.getAssessor(data, ASSESSOR_STATUS.REGISTRATION_COMPLETED).subscribe(assessor => {
			if (!assessor) {
				this.onAssessorIdChange();
				return;
			}
			this.assessor = assessor;
			this.linkAssessorFormControl.patchValues({
				nameOfAssessor: assessor.name
			});
			// this.linkNewAssesorForm.forms[0].formRef.controls.nameOfAssessor.setValue(
			// 	assessor.name
			// );
		});
	}
}
